var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 48,
    viewBox: "0 0 99 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 48,
    rx: 4,
    fill: "#59198C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 29H26.08V18.328H24.752V26.76L18.608 18.328H17.248V29H18.576V20.392L24.8 29ZM28.0801 25.128C28.0801 27.544 29.7281 29.192 32.0161 29.192C33.2801 29.192 34.3201 28.776 35.0881 28.008L34.5121 27.224C33.9041 27.848 33.0081 28.2 32.1281 28.2C30.4641 28.2 29.4401 26.984 29.3441 25.528H35.6001V25.224C35.6001 22.904 34.2241 21.08 31.8881 21.08C29.6801 21.08 28.0801 22.888 28.0801 25.128ZM31.8721 22.072C33.6321 22.072 34.4001 23.496 34.4161 24.648H29.3441C29.4081 23.464 30.2241 22.072 31.8721 22.072ZM42.0361 29H43.4281L40.4521 25.032L43.2521 21.272H41.8601L39.7161 24.216L37.5721 21.272H36.1801L38.9801 25.032L36.0201 29H37.3961L39.7161 25.832L42.0361 29ZM46.7614 29.192C47.4654 29.192 47.8974 28.984 48.2014 28.696L47.8494 27.8C47.6894 27.976 47.3694 28.12 47.0334 28.12C46.5054 28.12 46.2494 27.704 46.2494 27.128V22.328H47.8174V21.272H46.2494V19.16H45.0494V21.272H43.7694V22.328H45.0494V27.384C45.0494 28.536 45.6254 29.192 46.7614 29.192Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 24L74.0503 29L72.636 27.5714L75.1696 25.0121L63 25.0128V22.9925L75.1738 22.9921L72.636 20.4286L74.0503 19L79 24Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/next_button.1a1c0381500bfca042f287a4d5eb8824.svg";
export { ForwardRef as ReactComponent };